<template>
	<div>
		<!-- Based on dictionary render proper component to collect values -->
		<component
			:is="dictionary.componentName"
			v-bind="{ dictionary: dictionary }"
			:benefit="benefit"
			:values="values"
			@updated="
				$emit('updated', { values: $event, benefitClaimId: benefitClaimId })
			"
		/>
	</div>
</template>

<script>
import dictionary from "./dictionary.js"
import TemplateTable from "./TemplateTable"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon/"
/**
 * This is a higher order component that returns a component based on benfitId
 */

export default {
	components: { TemplateTable, JButton, CrmIcon },
	props: {
		/**
		 * BenefitId we are displaying template for e.g. medical_room
		 */
		benefitId: {
			type: String,
			default: "default"
		},

		/**
		 * ID of benefit for claims
		 */
		benefitClaimId: {
			type: String
		},

		/**
		 * Values that we get from API
		 *
		 */
		values: {
			type: Array,
			required: false,
			default: () => []
		},

		/**
		 * Benefit object we get from API claims it has few computed fields added such as remainigScalaValue and remainigValue
		 */
		benefit: {
			type: Object,
			default: () => ({
				remainingScalarValue: null,
				remainigValue: null
			})
    }
	},
	computed: {
		dictionary() {
			return dictionary(this.benefitId)
		}
	}
}
</script>